const middleware = {}

middleware['ensureUserAuth'] = require('../../../middleware/ensureUserAuth.ts')
middleware['ensureUserAuth'] = middleware['ensureUserAuth'].default || middleware['ensureUserAuth']

middleware['forceRecruiterToChargebeeCheckout'] = require('../../../middleware/forceRecruiterToChargebeeCheckout.ts')
middleware['forceRecruiterToChargebeeCheckout'] = middleware['forceRecruiterToChargebeeCheckout'].default || middleware['forceRecruiterToChargebeeCheckout']

middleware['globalAnalyticsMiddleware'] = require('../../../middleware/globalAnalyticsMiddleware.ts')
middleware['globalAnalyticsMiddleware'] = middleware['globalAnalyticsMiddleware'].default || middleware['globalAnalyticsMiddleware']

middleware['goToAppIfLoggedIn'] = require('../../../middleware/goToAppIfLoggedIn.ts')
middleware['goToAppIfLoggedIn'] = middleware['goToAppIfLoggedIn'].default || middleware['goToAppIfLoggedIn']

middleware['hyreAdminOnlyMiddleware'] = require('../../../middleware/hyreAdminOnlyMiddleware.ts')
middleware['hyreAdminOnlyMiddleware'] = middleware['hyreAdminOnlyMiddleware'].default || middleware['hyreAdminOnlyMiddleware']

middleware['saveSearchParams'] = require('../../../middleware/saveSearchParams.ts')
middleware['saveSearchParams'] = middleware['saveSearchParams'].default || middleware['saveSearchParams']

export default middleware
